// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Pr-v0tUS{display:flex;left:0;padding-top:3.13rem;top:0}._2v6O7w00{color:#000;font-size:1.13rem;line-height:1.39;padding:2.22em 0 0 2.22em}@media(max-width:1365.98px){.Pr-v0tUS{display:none}}._8NA8DNlN{color:#000;gap:1.19rem;padding-left:8.13rem}._8NA8DNlN>*{flex-basis:100%}@media(max-width:1365.98px){._8NA8DNlN{padding-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeline": "Pr-v0tUS",
	"timelineItem": "_2v6O7w00",
	"tracks": "_8NA8DNlN"
};
module.exports = ___CSS_LOADER_EXPORT___;
